import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { AssetBucketingDTO } from './useAssetBucketQuery';

const assetBucket = (data: AssetBucketingDTO) => {
  return authFetch('/Adviser/AssetBucketing/SaveAdviserLayout', {
    method: 'POST',
    ...httpBodyOptions(data, true),
  });
};

export const useAdvisorAssetBucketMutation = () => {
  return useMutation(assetBucket);
};
